export default {"src":"/hedera/_next/static/media/near_dark.a682065f.svg","height":10,"width":10};